@for (addon of addons; track addon; let idx = $index) {
  @if (idx + 1 <= pageSize) {
    <div class="addon-row" (click)="onRowClicked(addon)">
      <div class="product-details xmat-elevation-z2">
        <div>
          @if (addon.icon) {
            <img id="product-icon" [src]="addon.icon" />
          } @else {
            <mat-icon class="product-default-icon">add_circle</mat-icon>
          }
        </div>
        <div class="description-and-tagline">
          <div>
            <span class="addon-title">{{ addon.title }}</span>
          </div>
          <div>
            <span class="addon-tagline">{{ addon.tagline }}</span>
          </div>
        </div>
        <div class="pricing">
          <billing-ui-price-display
            [appPrice]="getAppPriceForIndex(idx)"
            [currencyCode]="currency"
            [align]="'end'"
          ></billing-ui-price-display>
        </div>
      </div>
    </div>
  }
}

@if (pageSize < addons.length) {
  <div class="load-more" (click)="onLoadMoreClicked()">
    <mat-icon>add</mat-icon>
    <span>Load more</span>
  </div>
}
